export default __webpack_public_path__ + "static/douglas2-af746780be0c4850f0b60394d18f715d.png";